module.exports = __webpack_public_path__ + "static/media/cloud-upload-file-grey.f22b19ef.svg";